// only for client side usage!
export function reActivateOptimizely () {
  if (
    window.optimizely &&
    window.optimizely.activate &&
    window.optimizely.activeExperiments.length !== 'undefined'
  ) {
    window.optimizely.activate(...window.optimizely.activeExperiments)
  }
}
